export const baseKeysUseQuery = {
  useLands: 'lands',
  useLandMarketInfo: 'land-market-info',
  useLandAccountInfo: 'land-account-info',
  useStableTokenBalance: 'stable-token-balance',
  useNativeTokenBalance: 'native-token-balance',
  useLimitOrdersIds: 'orders',
  useLimitOrders: 'order-book-order-by-id',
  useUserProfile: 'user-profile',
  useUserProfilePrivate: 'user-profile-private',
  useFundingStatus: 'funding-status',
  usePortfolioLandAssets: 'portfolio-land-assets',
};
